<template>
  <ui-modal
    v-bind="$attrs"
    :closable="false"
    footer-class="text-center"
  >
    <template #title>
      <div class="title">
        <slot name="title" />
      </div>
    </template>

    <template #body>
      <slot name="body" />
    </template>

    <template #footer>
      <slot name="footer" />
    </template>
  </ui-modal>
</template>

<script>
import Modal from '@/components/UI/modals/Modal'

export default {
  components: {
    UiModal: Modal,
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.title {
  line-height: 1.2;
  font-size: 22px;
  text-align: center;
  color: $primary-color;
}
</style>
